import {Dispatch, SetStateAction} from 'react';
import DotsLoading from '../../../../components/dotsLoading';
import Modal from '../../../../components/mazraeKit/modal';
import useDeleteLoanRequest from '../../../../services/hookService/deleteLoanRequest/useDeleteLoanRequest';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  loanGuid: string;
  title?: string;
  confirmationText?: string;
  removeText?: string;
  shouldRedirect?: boolean;
  onDelete?: () => void;
}

const CancelLoanConfirmModal = ({
  isOpen,
  setIsOpen,
  loanGuid,
  title = 'حذف مورد',
  confirmationText = 'از حذف این مورد مطمئن‌اید؟',
  removeText = 'حذف',
  shouldRedirect = true,
  onDelete,
}: IProps) => {
  const {mutate, isLoading} = useDeleteLoanRequest();

  const handleDeleteLoanRequest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    mutate(loanGuid, {
      onSuccess: () => {
        if (shouldRedirect) {
          window.location.href = '/my-credits/startLoanCredit'; // Navigate AND refresh. this is needed to avoid white screen step when user comes back to step pages
        }
        onDelete?.();
        setIsOpen(false);
      },
    });
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="relative w-[320px] flex flex-col p-4 gap-3 z-[999]">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute left-5 top-5"
        >
          <i className="text-2xl text-gray-700 icon-nameClose-remove" />
        </button>

        <div className="flex flex-col items-center gap-1">
          <i className="text-5xl text-red-500 icon-warning-triangle" />
          <h5 className="font-medium text-gray-950 text-md">{title}</h5>
        </div>

        <p className="mb-0 text-center text-neutral-600 text-md font-Regular">
          {confirmationText}
        </p>

        <div className="flex items-center gap-2 mt-2">
          <button
            className="w-full h-10 text-sm bg-transparent border rounded text-farm-shop-500 border-farm-shop-500"
            onClick={e => {
              e.stopPropagation();
              setIsOpen(false);
            }}
          >
            انصراف
          </button>

          <button
            className="grid w-full h-10 text-sm text-white bg-red-500 rounded place-content-center disabled:bg-gray-400"
            disabled={isLoading}
            onClick={handleDeleteLoanRequest}
          >
            {isLoading ? <DotsLoading /> : removeText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelLoanConfirmModal;
